<!--suppress ALL -->
<script lang="ts">
import {sekolahSantries} from '../../../util/PluralVariabels';
  import {Component, Vue, Prop} from 'annotation';
  import {cloneArray} from "../../../util/Underscore";

  import GField from '../common/field/GField.vue';
  import GSelect from '../common/select/GSelect.vue';

  @Component
  export default class SekolahSantriSelect extends Vue {

    @Prop({default: sekolahSantries[0].value, type: String})
    public sekolah: string;

    @Prop({default: false, type: Boolean})
    public skipLabel: boolean;

    @Prop({default: true, type: Boolean})
    public isFullwidth: boolean;

    @Prop({type: String, default: null})
    public type: any;

    @Prop({type: String, default: null})
    public message: any;

    @Prop({type: Boolean, default: false})
    public disabled: any;

    public onSelectSekolah(param: any) {
      this.$emit('update:sekolah', param || sekolahSantries[0].value);
      this.$emit('sekolah-selected', param);
    }

    public render(createElement: Function) {
      const {$t, sekolah, isFullwidth, message, type} = this;

      const mainAttr: any = {
        props: {
          value: sekolah,
          isFullwidth, placeholder: `${$t('label.choose')} ${$t('label.sekolah_santri')}`
        },
        attrs: {disabled: this.disabled},
        on: {change: this.onSelectSekolah}
      };

      const main: any = createElement(GSelect, mainAttr, cloneArray(sekolahSantries).map((item: any) => {
        const option: any = {attrs: {value: item.value}};

        return createElement('option', option, item.label.toUpperCase());
      }));

      if (this.skipLabel) {
        return main;
      }

      return createElement(GField, {props: {label: $t('label.sekolah_santri'), message, type}}, [main]);
    }
  }
</script>
